import { Link } from 'react-router-dom';
import usePlan from '../hooks/usePlan';

export default function PlanGate({ minPlan, feature, children, inline = false, message }) {
  const { plan, meetsMinPlan, hasFeature } = usePlan();

  const hasAccess = minPlan ? meetsMinPlan(minPlan) : feature ? hasFeature(feature) : true;

  if (hasAccess) {
    return children;
  }

  const defaultMsg = minPlan
    ? `Disponivel a partir do plano ${minPlan.charAt(0).toUpperCase() + minPlan.slice(1)}`
    : 'Faca upgrade para acessar esta funcionalidade';

  if (inline) {
    return (
      <div className="relative group">
        <div className="opacity-40 pointer-events-none select-none">
          {children}
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-[1px] rounded-xl">
          <div className="text-center px-4">
            <svg className="w-8 h-8 text-orca-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <p className="text-sm font-medium text-gray-700 mb-2">{message || defaultMsg}</p>
            <Link
              to="/planos"
              className="inline-block px-4 py-1.5 bg-orca-600 text-white text-xs font-bold rounded-lg hover:bg-orca-700 transition-colors"
            >
              Ver planos
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border-2 border-dashed border-gray-200 rounded-xl p-6 text-center bg-gray-50">
      <svg className="w-10 h-10 text-orca-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
      <p className="text-sm font-semibold text-gray-700 mb-1">{message || defaultMsg}</p>
      <p className="text-xs text-gray-500 mb-4">Seu plano atual: {plan.label}</p>
      <Link
        to="/planos"
        className="inline-block px-6 py-2.5 bg-orca-600 text-white text-sm font-bold rounded-xl hover:bg-orca-700 transition-colors"
      >
        Fazer upgrade
      </Link>
    </div>
  );
}
